import {BasicClient} from '@/utils/httpClient';

export default class Menu {
  client: BasicClient;
  constructor(){
    this.client = new BasicClient();
  }
  getUser():any{
    let cachedData = localStorage.getItem('actions');
    if (cachedData) {
     
      cachedData = JSON.parse(cachedData);
        return Promise.resolve(cachedData);
      }
    
    else {
    return this.client.exec('/actions/available', 'GET')
      .then(response => {
        localStorage.setItem('actions', JSON.stringify(response));
        return Promise.resolve(response);
      })
      .catch(error => {
        return Promise.reject(error);
      });}
    
  }
}